import {useFocusEffect} from '@react-navigation/native';
import * as React from 'react';
import {Dispatch, SetStateAction} from 'react';

export const useScreenState = <T>(defaultValue: T): [T, Dispatch<SetStateAction<T>>] => {
  const [value, setValue] = React.useState<T>(defaultValue);

  useFocusEffect(
    React.useCallback(() => {
      return () => setValue(defaultValue);
    }, [defaultValue]),
  );

  return [value, setValue];
};
